module.exports = __webpack_public_path__ + "static/media/cargando.315d0bba.png";